import { createFileRoute } from '@tanstack/react-router';

import {
  attributesQueryOptions,
  customizationsQueryOptions,
  productTypeQueryOptions,
  ProductTypesPage,
} from '@/features/dictionary';

export const Route = createFileRoute(
  '/_authed/_active/org/catalog-setup/product-types/$productTypeId',
)({
  loader: async ({ context, params }) => {
    const [productType] = await Promise.all([
      context.queryClient.query({
        ...productTypeQueryOptions(params.productTypeId),
        staleTime: 'static',
      }),
      context.queryClient
        .query({ ...attributesQueryOptions(), staleTime: 'static' })
        .catch(() => undefined),
      context.queryClient
        .query({ ...customizationsQueryOptions(), staleTime: 'static' })
        .catch(() => undefined),
    ]);
    return { crumb: productType.name };
  },
  component: ProductTypeDetail,
});

function ProductTypeDetail() {
  const { productTypeId } = Route.useParams();
  return <ProductTypesPage view="edit" productTypeId={productTypeId} />;
}
